import { MouseEvent, useMemo } from 'react';

import { ApiNotification } from 'api/notification/types/ApiNotification';
import { MappedLocalNotification } from 'types/LocalNotification/MappedLocalNotification';
import { MappedNotification } from 'types/mappedNotifications/MappedNotification';
import { getMappedNotificationIds } from 'utils/userNotifications';

import { LocalNotificationListItem } from './Item/variants/LocalNotificationListItem';
import { UserNotificationListItem } from './Item/variants/UserNotificationListItem';

type Props = {
  notifications: (ApiNotification | MappedNotification)[];
  localNotifications: MappedLocalNotification[];
  dismissible?: boolean;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
};

export function NotificationList({
  notifications,
  localNotifications,
  dismissible,
  onClick,
}: Props) {
  const sortedNotifications = useMemo(
    () =>
      notifications
        .slice()
        .sort((a, b) => Date.parse(b.created) - Date.parse(a.created)),
    [notifications],
  );

  return (
    <>
      {localNotifications.map((notification) => (
        <LocalNotificationListItem
          key={notification.type}
          notification={notification}
          dismissible={Boolean(dismissible)}
          onClick={onClick}
        />
      ))}

      {sortedNotifications.map((notification) => (
        <UserNotificationListItem
          key={getMappedNotificationIds(notification).join()}
          notification={notification}
          dismissible={Boolean(dismissible)}
          onClick={onClick}
        />
      ))}

      {notifications.length === 0 && localNotifications.length === 0 && (
        <div style={{ padding: 20, width: '100%', textAlign: 'center' }}>
          {getText('You are all up to date! 🎉')}
        </div>
      )}
    </>
  );
}
